export function getImage(src: string | null | undefined) {
    if (![ '', null, 'null', undefined, 'undefined' ].includes(src)) {
        return src;
    }
    return './dist/src/img/noImg.png';
}
